import isUndefined from "lodash.isundefined";
import isString from "lodash.isstring";
import { virtualFolderIds, virtualFolderNames } from "../constants";

const isVirtualFolder = (folderIdOrName?: string) => {
  // not a virtual folder if the id/name is undefined
  if (
    isUndefined(folderIdOrName) ||
    (isString(folderIdOrName) && folderIdOrName.length === 0)
  ) {
    return false;
  }
  // virtual folder if the id matches the known list
  if (virtualFolderIds.includes(folderIdOrName)) {
    return true;
  }
  // virtual folder if the name is in the virtual folder name map
  if (!isUndefined(virtualFolderNames[folderIdOrName])) {
    return true;
  }

  return false;
};

export default isVirtualFolder;
